import { HTMLChakraProps } from '@chakra-ui/react';
import { FC } from 'react';

import { EventSearchInputWithoutSession } from '@/components/ui/features/events-list/EventSearchInput/EventSearchInputWithoutSession';
import { EventSearchInputWithSession } from '@/components/ui/features/events-list/EventSearchInput/EventSearchInputWithSession';
import { IOption } from '@/components/ui/shared/DropdownSelect/DropdownSelect';
import { SearchGroup } from '@/enums';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const searchGroups: Array<IOption> = [
  { id: SearchGroup.ALL, value: 'All' },
  { id: SearchGroup.EVENT_SESSION, value: 'Sessions' },
  { id: SearchGroup.LECTURE, value: 'Lectures' },
  { id: SearchGroup.SPEAKERS, value: 'Authors' },
];

interface IUrlQueryStringParams {
  eventSessionId?: string;
}

export const EventSearchInput: FC<HTMLChakraProps<'div'>> = (props) => {
  const { eventSessionId } = useQueryParams<IUrlQueryStringParams>({
    eventSessionId: StringParam,
  });

  if (eventSessionId) return <EventSearchInputWithSession {...props} />;

  return <EventSearchInputWithoutSession {...props} />;
};
